<template>
    <div>
        <g-typography
            v-if="isBriefAccepted"
            :value="acceptedBy"
            tag="div"
            color="orange-5"
            font-weight="semibold"
            size="small"
            :margins="true"
            margin-class="mb-3"
        />
        <div v-if="customContentRights">
            <div v-html="$sanitize(customContentRights)" />
        </div>
        <div v-else class="content-rights-text">
            <g-typography :value="contentRightsHeader" />
            <ul class="list-styling">
                <li v-for="(right, index) in selectedContentRightsList" :key="index">
                    <g-typography :value="right.text" />
                </li>
            </ul>
        </div>
        <g-level v-if="files">
            <g-level-item v-for="file in files" :key="file.id">
                <g-tag theme="basic">
                    <g-link :href="file.url" target="_blank">
                        <g-tooltip :title="file.name" placement="topLeft">
                            <g-typography size="small"> {{ file.name }}</g-typography>
                        </g-tooltip>
                        <g-icon name="paperclip" size="small" />
                    </g-link>
                </g-tag>
            </g-level-item>
        </g-level>
    </div>
</template>

<script>
    import { get } from 'lodash';
    import moment from 'moment-timezone';
    import { getActivationFiles } from '../../../../../helpers/activations/activation-files';
    import ActivationBriefMixin from '../../mixins/ActivationBriefMixin';

    export default {
        name: 'ContentRightsSummary',
        mixins: [ActivationBriefMixin],
        props: {
            brief: {
                type: Object,
                required: true
            }
        },
        methods: {
            formatDate(isoDate) {
                return moment(isoDate).format('lll');
            }
        },
        computed: {
            acceptedBy() {
                let acceptedByName = this.brief.accepted_by_name;

                if (this.brief.accepted_by === 'user') {
                    acceptedByName = this.brief.brand.name;
                }

                return this.isBriefAccepted
                    ? `Accepted by ${acceptedByName} on ${this.formatDate(this.brief.accepted_at)}`
                    : null;
            },
            existingContentRights() {
                return get(this.brief, 'content_rights.content_rights', false)
                    ? get(this.brief, 'content_rights.content_rights', {})
                    : get(this.brief, 'content_rights', {});
            },

            selectedContentRightsList() {
                return get(this.existingContentRights, 'standard_content_rights.selected_content_rights', []);
            },

            contentRightsHeader() {
                return get(this.existingContentRights, 'content_rights_header', '');
            },

            customContentRights() {
                return get(this.existingContentRights, 'custom_content_rights', '');
            },

            files() {
                return getActivationFiles(this.brief.files, 'content_agreement');
            }
        }
    };
</script>

<style lang="scss" scoped>
    .content-rights-text {
        line-height: 1.25;
    }

    .step-card-current .content-rights-text .g-text-body {
        color: white;
    }
</style>
